import React from 'react'
import classnames from 'classnames'
import './UserPicture.scss'
import { useNavigate } from 'react-router-dom'
import { userUrl } from '@/urls'
import DefaultAvatarImage from '@/assets/images/default_avatar.png'
import { i18n } from '@/locale/i18n'

export default function UserPicture({
  user,
  children,
  height,
  width,
  enableNavigateToProfile = false,
  imageClassName = 'rounded-[var(--radius-circular)]',
  onUserClick = () => {},
  ...props
}) {
  const navigate = useNavigate()

  // User avatars are always round (see UserPicture.scss) — --radius-circular is the design-system token
  const classList = classnames('user-picture', 'rounded-[var(--radius-circular)]', props.className)

  let style = {}

  if (user && user.picture) {
    style.backgroundImage = 'none'
  }

  if (height) {
    style.height = height + 'px'
  }

  if (width) {
    style.width = width + 'px'
  }

  const handleOnClick = () => {
    if (enableNavigateToProfile) {
      navigate(userUrl(user))
    }

    onUserClick()
  }

  return (
    <div className={classList} style={style} onClick={handleOnClick}>
      {user && user.picture && (
        <img
          src={user.picture}
          className={`user-picture-img w-full h-full object-cover ${imageClassName}`}
          alt={user.username + "'s picture"}
          title={user.username + "'s picture"}
        />
      )}
      {(!user || !user.picture) && (
        <img
          src={DefaultAvatarImage}
          className={`user-picture-img w-full h-full object-cover ${imageClassName}`}
          alt={i18n('profile.anonymous')}
          title={i18n('profile.anonymous')}
        />
      )}
      {children}
    </div>
  )
}
